(function () {
hubspot.define('hubspot.reagan.mixer', ['Backbone', 'Reagan/reagan'], function(Backbone, Reagan) {
  var ReaganMixer;
  return ReaganMixer = (function() {
    function ReaganMixer() {}

    ReaganMixer.prototype.initialPageLoad = true;

    ReaganMixer.prototype.initialize = function() {
      var currentRoute, options;
      ReaganMixer.__super__.initialize.apply(this, arguments);
      options = {
        slowPageStart: this.slowPageStart,
        timeout: this.timeout
      };
      this.reagan = new Reagan(options);
      currentRoute = null;
      Backbone.history.on('route', (function(_this) {
        return function(router, route) {
          var ref, ref1, tests;
          _this.reagan.stop();
          currentRoute = route;
          tests = _this.getTests(route);
          if ((ref = window.newrelic) != null) {
            if (typeof ref.setCustomAttribute === "function") {
              ref.setCustomAttribute('route', route);
            }
          }
          if ((ref1 = window.newrelic) != null) {
            if (typeof ref1.setCurrentRouteName === "function") {
              ref1.setCurrentRouteName(route);
            }
          }
          if (!tests) {
            if (typeof console !== "undefined" && console !== null) {
              if (typeof console.warn === "function") {
                console.warn("No Reagan test for " + route);
              }
            }
            _this.initialPageLoad = false;
          }
          return _this.reaganCheck(route, tests, true);
        };
      })(this));
      if (this.resources) {
        console.warn('Reagan resource timing no longer exists, you should remove the `resources` array on your router');
      }
      if (this.deferredRoutes != null) {
        document.addEventListener('Reagan.success', (function(_this) {
          return function() {
            var base, base1;
            if (currentRoute) {
              if (typeof (base = _this.deferredRoutes)[currentRoute] === "function") {
                base[currentRoute]({
                  success: true
                });
              }
            }
            return typeof (base1 = _this.deferredRoutes).__all__ === "function" ? base1.__all__({
              success: true
            }) : void 0;
          };
        })(this));
        document.addEventListener('Reagan.failure', (function(_this) {
          return function() {
            var base, base1;
            if (currentRoute) {
              if (typeof (base = _this.deferredRoutes)[currentRoute] === "function") {
                base[currentRoute]({
                  success: false
                });
              }
            }
            return typeof (base1 = _this.deferredRoutes).__all__ === "function" ? base1.__all__({
              success: false
            }) : void 0;
          };
        })(this));
      }
    };

    ReaganMixer.prototype.getTests = function(route) {
      var ref;
      return (ref = this.tests) != null ? ref[route] : void 0;
    };

    ReaganMixer.prototype.reaganCheck = function(route, params, immediate) {
      var options;
      if (immediate == null) {
        immediate = false;
      }
      options = {
        startTimerOnPageLoad: this.initialPageLoad
      };
      this.initialPageLoad = false;
      if (immediate) {
        return this.reagan.check(route, params, options);
      } else {
        return setTimeout((function(_this) {
          return function() {
            return _this.reagan.check(route, params, options);
          };
        })(this), 0);
      }
    };

    return ReaganMixer;

  })();
});
}());

